export const allTheOtherFields = [
  { label: "Appliances", value: "appliances" },
  { label: "Architectural styles", value: "architecturalStyles" },
  { label: "Assessed values", value: "assessedValues" },
  { label: "Building name", value: "buildingName" },
  { label: "Categories", value: "categories" },
  { label: "CBSA code", value: "cbsaCode" },
  { label: "CBSA name", value: "cbsaName" },
  { label: "Census block", value: "censusBlock" },
  { label: "Census block group", value: "censusBlockGroup" },
  { label: "Census tract", value: "censusTract" },
  { label: "Congressional district house", value: "congressionalDistrictHouse" },
  { label: "City", value: "city" },
  { label: "Civil division code", value: "civilDivisionCode" },
  { label: "Civil division name", value: "civilDivisionName" },
  { label: "Country", value: "country" },
  { label: "County", value: "county" },
  { label: "County FIPS", value: "countyFIPS" },
  { label: "Current owner type", value: "currentOwnerType" },
  { label: "Date added", value: "dateAdded" },
  { label: "Date updated", value: "dateUpdated" },
  { label: "Deposits", value: "deposits" },
  { label: "Descriptions", value: "descriptions" },
  { label: "Domains", value: "domains" },
  { label: "Estimated prices", value: "estimatedPrices" },
  { label: "Exterior construction", value: "exteriorConstruction" },
  { label: "Exterior features", value: "exteriorFeatures" },
  { label: "Features", value: "features" },
  { label: "Fees", value: "fees" },
  { label: "Floor plans", value: "floorPlans" },
  { label: "Floor size value", value: "floorSizeValue" },
  { label: "Floor size unit", value: "floorSizeUnit" },
  { label: "Geo location", value: "geoLocation" },
  { label: "Geo quality", value: "geoQuality" },
  { label: "HVAC types", value: "hvacTypes" },
  { label: "Instrument number", value: "instrumentNumber" },
  { label: "Keys", value: "keys" },
  { label: "Languages spoken", value: "languagesSpoken" },
  { label: "Latitude", value: "latitude" },
  { label: "Leasing terms", value: "leasingTerms" },
  { label: "Legal description", value: "legalDescription" },
  { label: "Legal range", value: "legalRange" },
  { label: "Listing name", value: "listingName" },
  { label: "Longitude", value: "longitude" },
  { label: "Lot size value", value: "lotSizeValue" },
  { label: "Lot size unit", value: "lotSizeUnit" },
  { label: "Managed by", value: "managedBy" },
  { label: "MLS number", value: "mlsNumber" },
  { label: "Most recent broker agent", value: "mostRecentBrokerAgent" },
  { label: "Most recent broker company", value: "mostRecentBrokerCompany" },
  { label: "Most recent broker date seen", value: "mostRecentBrokerDateSeen" },
  { label: "Most recent broker emails", value: "mostRecentBrokerEmails" },
  { label: "Most recent broker phones", value: "mostRecentBrokerPhones" },
  { label: "Most recent owner first name", value: "mostRecentOwnerFirstName" },
  { label: "Most recent owner last name", value: "mostRecentOwnerLastName" },
  { label: "Most recent price currency", value: "mostRecentPriceCurrency" },
  { label: "Most recent price domain", value: "mostRecentPriceDomain" },
  { label: "Most recent rental list price amount", value: "mostRecentRentalListPriceAmount" },
  { label: "Most recent rental list price date", value: "mostRecentRentalListPriceDate" },
  { label: "Most recent rental status", value: "mostRecentRentalStatus" },
  { label: "Most recent sale list price amount", value: "mostRecentSaleListPriceAmount" },
  { label: "Most recent sale list price date", value: "mostRecentSaleListPriceDate" },
  { label: "Most recent sold price amount", value: "mostRecentSoldPriceAmount" },
  { label: "Most recent sold price date", value: "mostRecentSoldPriceDate" },
  { label: "Most recent status", value: "mostRecentStatus" },
  { label: "Most recent status date", value: "mostRecentStatusDate" },
  { label: "Most recent status first date seen", value: "mostRecentStatusFirstDateSeen" },
  { label: "MSA code", value: "msaCode" },
  { label: "MSA name", value: "msaName" },
  { label: "Neighborhoods", value: "neighborhoods" },
  { label: "Number of bathrooms", value: "numBathroom" },
  { label: "Number of bedrooms", value: "numBedroom" },
  { label: "Number of floors", value: "numFloor" },
  { label: "Number of parking spaces", value: "numParkingSpaces" },
  { label: "Number of people", value: "numPeople" },
  { label: "Number of rooms", value: "numRoom" },
  { label: "Number of units", value: "numUnit" },
  { label: "Owner occupied", value: "ownerOccupied" },
  { label: "Owners", value: "owners" },
  { label: "Parking", value: "parking" },
  { label: "Parking types", value: "parkingTypes" },
  { label: "Parcel numbers", value: "parcelNumbers" },
  { label: "Payment types", value: "paymentTypes" },
  { label: "People", value: "people" },
  { label: "Pet policy", value: "petPolicy" },
  { label: "Phones", value: "phones" },
  { label: "Postal or Zip code", value: "postalCode" },
  { label: "Prices", value: "prices" },
  { label: "Property taxes", value: "propertyTaxes" },
  { label: "Property type", value: "propertyType" },
  { label: "Province or State", value: "province" },
  { label: "Reviews", value: "reviews" },
  { label: "Roofing", value: "roofing" },
  { label: "Room types", value: "roomTypes" },
  { label: "Rules", value: "rules" },
  { label: "Status History", value: "statusHistory" },
  { label: "Statuses", value: "statuses" },
  { label: "Subdivision", value: "subdivision" },
  { label: "Tax exemptions", value: "taxExemptions" },
  { label: "Tax ID", value: "taxID" },
  { label: "Title", value: "title" },
  { label: "Topography code", value: "topographyCode" },
  { label: "Trust description", value: "trustDescription" },
  { label: "Website IDs", value: "websiteIDs" },
  { label: "Year built", value: "yearBuilt" },
  { label: "Zoning", value: "zoning" }
];


export const mostCommonFieldsList = [
  { label: "Address", value: "address" },
  { label: "Brokers", value: "brokers" },
  { label: "Image URLs", value: "imageURLs" },
  { label: "Transactions", value: "transactions" }
];
